import React from 'react';

interface RowTypes {
  place?: React.ReactNode;
  name?: React.ReactNode;
  amount?: string;
  value?: string;
  totalValue: string;
  className?: string;
  isRowTotal?: boolean;
}

const TableRow = ({
  place,
  name,
  amount,
  value,
  totalValue,
  className,
  isRowTotal,
}: RowTypes): JSX.Element => {
  return (
    <tr className={`${className}`}>
      <td className="border-check" colSpan={isRowTotal ? 4 : 1}>
        {place}
      </td>
      {!isRowTotal ? <td>{name}</td> : ''}
      {!isRowTotal ? <td>{value}</td> : ''}
      {!isRowTotal ? <td>{amount}</td> : ''}
      <td>{totalValue}</td>
    </tr>
  );
};

export default TableRow;
